import { FC, PropsWithChildren } from "react";
import styles from "./Form.module.scss";
import FormHeadline from "./FormHeadline";
import FormItems from "./FormItems";
import FormItem from "./FormItem";
import Input from "@components/ui/input";
import { FieldValues, FormState, UseFormRegister } from "react-hook-form";

interface Props {
    onSubmit?(): void;
    register: UseFormRegister<FieldValues>;
    formState: FormState<FieldValues>;
}

const Form: FC<PropsWithChildren & Props> = ({ onSubmit, children, register, formState: { errors } }) => {
    const formItems = [
        {
            name: "name",
            label: "Name",
            placeholder: "TON",
            required: true,
        },
        {
            name: "address",
            label: "The address of the presale or project or NFT",
            placeholder: "UQDmN...6JX8H",
            required: true,
        },
        {
            name: "twitter",
            label: "Twitter",
            placeholder: "x.com",
            required: true,
        },
        {
            name: "telegram",
            label: "Telegram channel",
            placeholder: "t.me/channel",
            required: true,
        },
        {
            name: "comment",
            label: "Comment",
            placeholder: "The project does not have a roadmap",
            required: true,
        },
    ];
    return (
        <form onSubmit={onSubmit} className={styles.block}>
            <FormHeadline />
            <FormItems>
                {formItems.map(({ name, label, placeholder, required }) => (
                    <FormItem key={name} id={name} label={label}>
                        <Input
                            error={errors[name]}
                            name={name}
                            placeholder={placeholder}
                            id={name}
                            required={required}
                            type="text"
                            register={register}
                        />
                    </FormItem>
                ))}
            </FormItems>
            {children}
        </form>
    );
};

export default Form;
